const FilterSelectedValues = (options) => {
    if(options && Array.isArray(options)) {
        let finalValueList = options.map((item) => item.value);
        return finalValueList;
    }
}

export default FilterSelectedValues;